<template>
	<b-overlay :show="showOverlay" rounded="sm">
		<b-card class="sa-card sa-card-dashbord sa-page-dashboard-card-body-chart" style="height: 100%" :header="chartParams.title" header-tag="header" footer-tag="footer" title="">
			<template #header>
				<div style="display: flex">
					<span style="flex: 1">{{ chartParams.title }}</span>

					<b-button v-if="!view" size="sm" variant="outline-secondary outline-secondary-noborder pull-right" @click="onClickEditConfigChart()">
						<i class="fas fa-pencil-alt"></i>
					</b-button>
					<b-button v-if="!view" size="sm" variant="outline-danger outline-secondary-noborder pull-right" @click="onClickRimuoviOggetto()">
						<i class="fas fa-trash"></i>
					</b-button>
					<b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right" @click="onClickZoomChart(chartParams)">
						<i class="fas fa-search-plus"></i>
					</b-button>
					<b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right" @click="onClickViewData(chartParams)">
						<i class="fas fa-database"></i>
					</b-button>
					<b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right" @click="onClickEditDetails()"> <i class="far fa-edit"></i></b-button>
				</div>
			</template>
			<b-card-body>
				<div class="sa-page-dashboard-body-graphic" style="height: 400px">
					<v-chart :option="chartOption" autoresize class="sa-widget-chart" />
				</div>
				<!-- <div v-else>
					<p>2</p>
					<p>{{ chartParams }}</p>
					<b-card-text class="text-right sa-dashboard-data-text">{{ chartParams.value }}</b-card-text>
				</div> -->
			</b-card-body>
		</b-card>
		<widget-editor ref="cmpWidgetEditor" :config="mxChartConfig" @updateConfig="updateConfig" />
		<data-analysis-chart-view-modal-component ref="mdlDataAnalysisChartViewModalComponent"></data-analysis-chart-view-modal-component>
		<data-analysis-dashboard-pivot-edit-modal-component
			ref="mdlDataAnalysisDashboardPivotEditModalComponent"
			@beforeLoadData="onBeforeLoadDataMdlDataAnalysisDashboardPivotEditModalComponent"
			@afterLoadData="onAfterLoadDataMdlDataAnalysisDashboardPivotEditModalComponent"
			@updatePivotParams="onUpdatePivotParams"
		></data-analysis-dashboard-pivot-edit-modal-component>
	</b-overlay>
</template>

<script>
// import { SaModalLoading } from "../../../template/components/modal";
// import GenericChartComponent from "../../utility/components/GenericChartComponent.vue";
// import DataAnalysisModalViewDataComponent from "./DataAnalysisModalViewDataComponent.vue";
import DataAnalysisChartViewModalComponent from "./DataAnalysisChartViewModalComponent.vue";
// import DataAnalysisEditConfigChartModalComponent from "./DataAnalysisEditConfigChartModalComponent.vue";
// import DataAnalysisDashboardPivotEditModalComponent from "./DataAnalysisDashboardPivotEditModalComponent.vue";
// 1. Importa ECharts e il wrapper
import ECharts from "vue-echarts";
import { use } from "echarts/core";

// 2. Importa i moduli di ECharts (necessario per non caricare tutto il pacchetto)
import { CanvasRenderer } from "echarts/renderers";
import { BarChart, LineChart, PieChart } from "echarts/charts";
import { GridComponent, TooltipComponent, LegendComponent } from "echarts/components";
import WidgetEditor from "./WidgetEditorNuovo.vue";
import DataAnalysisDashboardPivotEditModalComponent from "./DataAnalysisDashboardPivotEditModalComponent.vue";
// 3. Registra i moduli
use([CanvasRenderer, BarChart, LineChart, PieChart, GridComponent, TooltipComponent, LegendComponent]);
import DataAnalysisChartMixin from "../mixins/DataAnalysisChartMixinKekkoStrunz";
export default {
	props: {
		chartParams: { type: Object },
		view: {
			type: Boolean,
			default: () => {
				return false;
			},
		},
	},
	mixins: [DataAnalysisChartMixin],
	// components: { SaModalLoading, GenericChartComponent, DataAnalysisModalViewDataComponent, DataAnalysisChartViewModalComponent, DataAnalysisEditConfigChartModalComponent, DataAnalysisDashboardPivotEditModalComponent },
	components: {
		// 4. REGISTRAZIONE LOCALE: Questo risolve l'errore "Unknown custom element"
		"v-chart": ECharts,
		WidgetEditor,
		DataAnalysisChartViewModalComponent,
		DataAnalysisDashboardPivotEditModalComponent,
	},
	created() {
		this.mxChartConfig = JSON.parse(JSON.stringify(this.chartParams));
	},
	data() {
		return {
			isTableView: false,
			pathResourceData: "/dataanalysisdatabaseinfo/eseguigraphicquery",
			queryResult: [],
			//testChartParams: { id: 1, title: "Grafico di Test", graphicType: null, colorPalette: "standard", idQuery: "12f463db-0771-4241-90d7-78163a3273fb", field: null, cols: 12, xs: 12, sm: 12, md: 12, lg: 6, xl: 6, seriesConfigs: [] },
		};
	},
	mounted() {
		this.queryLoadData();
	},
	methods: {
		formatDate(timestamp, granularity) {
			if (!timestamp) return "N/A";

			let d;

			// Controllo del tipo di dato
			if (typeof timestamp === "number") {
				// È un Unix Timestamp in millisecondi (es. 1748941275663)
				d = new Date(timestamp);
			} else {
				// È una stringa (es. "2025-06-03 09:05:59")
				const cleanDate = timestamp.toString().replace(" ", "T");
				d = new Date(cleanDate);
			}

			// Verifica se la data è valida
			if (isNaN(d.getTime())) return "Data non valida";

			const year = d.getFullYear();
			const month = String(d.getMonth() + 1).padStart(2, "0");
			const day = String(d.getDate()).padStart(2, "0");

			switch (granularity) {
				case "year":
					return `${year}`;
				case "month":
					return `${year}-${month}`;
				case "day":
					return `${year}-${month}-${day}`;
				default:
					return `${year}-${month}-${day}`;
			}
		},
		refreshWidget() {
			this.$emit("refresh", this.chartParams.idQuery);
		},
		updateConfig(newConfig) {
			// Aggiorniamo la config locale.
			// Se la config viene dal padre, è meglio fare un emit al padre:
			this.$emit("updateChart", newConfig);

			// Se stiamo aggregando dati, meglio rieseguire prepareData
			this.queryResult = this.prepareData(this.rawResponseData, newConfig);
		},
		onClickEditConfigChart() {
			console.log(this.chartParams);
			this.$refs.cmpWidgetEditor.init(this.chartParams);
			//this.$bvModal.show("modal-edit-" + this.chartParams.id);
		},
		onClickRimuoviOggetto() {
			this.$emit("removeObject", this.chartParams);
		},
		onClickZoomChart() {
			let me = this;
			//let chartParams = { title: me.chartParams.title, headerElements: [], bodyElement: me.chartParams, chartData: me.chartData };
			me.$refs.mdlDataAnalysisChartViewModalComponent.setChartParams(this.chartParams);
			me.$refs.mdlDataAnalysisChartViewModalComponent.show();
		},
		onClickEditDetails() {
			this.$refs.mdlDataAnalysisDashboardPivotEditModalComponent.show(this.chartParams);
		},
		onBeforeLoadDataMdlDataAnalysisDashboardPivotEditModalComponent() {
			//this.$refs.cmpSaModalLoading.show();
		},
		onAfterLoadDataMdlDataAnalysisDashboardPivotEditModalComponent() {
			//this.$refs.cmpSaModalLoading.close();
		},
		onUpdatePivotParams() {},
	},
};
</script>

<style></style>
